//region :: Imports ::
import React, {ReactElement} from 'react';
import {Outlet} from 'react-router-dom';
import {BlockUITemplateType} from 'primereact/blockui';
import {loadUITheme, MNullable, MUnhandledError, unpackUnhandledError} from '../../Utils';
import MComponent from '../Component';
import MBlockUI from '../Controls/BlockUI';
import Logger from '../Logging/Logger';
import MBlockUIErrorTemplate from '../Controls/BlockUIErrorTemplate';

//endregion

/** */
type Props = {}

/** */
type State = {
    unhandledError: MNullable<MUnhandledError>;
}

/** */
class MAppContainer extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.window_error = this.window_error.bind(this);
        this.window_unhandledRejection = this.window_unhandledRejection.bind(this);

    }

    /** */
    private initializeState(): void {
        this.state = {unhandledError: null};
    }

    /** */
    private getLockTemplate(): BlockUITemplateType {

        return (
            this.state.unhandledError !== null &&
            <MBlockUIErrorTemplate message={this.state.unhandledError!.errorMessage!}/>
        );

    }

    /** */
    private window_error(errorEvent: ErrorEvent): any {

        const unhandledError = unpackUnhandledError(errorEvent.error);
        Logger.trackError(unhandledError.exception);
        this.safeSetState((draft: State) => draft.unhandledError = unhandledError);

    }

    /** */
    private window_unhandledRejection(errorEvent: PromiseRejectionEvent): any {

        const unhandledError = unpackUnhandledError(errorEvent.reason);
        Logger.trackError(unhandledError.exception);
        this.safeSetState((draft: State) => draft.unhandledError = unhandledError);

    }

    /** */
    public componentDidMount(): void {

        window.addEventListener('error', this.window_error);
        window.addEventListener('unhandledrejection', this.window_unhandledRejection);

        loadUITheme();

    }

    /** */
    public componentWillUnmount(): void {

        window.removeEventListener('error', this.window_error);
        window.removeEventListener('unhandledrejection', this.window_unhandledRejection);

    }

    /** */
    public render(): ReactElement {

        const locked = this.state.unhandledError !== null;

        return (
            <MBlockUI locked={locked}
                      fullscreen={true}
                      template={this.getLockTemplate()}>

                <Outlet/>

            </MBlockUI>
        );

    }

}

export default MAppContainer;
